import { Component, ElementRef, Input, OnDestroy } from '@angular/core';
import { fromEvent, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss'],
})
export class TooltipComponent implements OnDestroy {
  active: boolean;
  @Input() disabled: boolean = false;
  @Input() link: string;
  @Input() useBothTogglers: boolean = false;
  @Input() text: string;
  @Input() linkCss: string;

  private clickSubscription: Subscription;

  constructor(private tooltip: ElementRef) {}

  ngOnDestroy(): void {
    this.unsubscribeClick();
  }

  /**
   * If tooltip is disabled, then don't toggle it.
   * If tooltip is active (opened), then subscribe to click event for closing when you click somewhere except tooltip.
   * If tooltip is not active (closed), then unsubscribe from click event so the listener is not active.
   */
  toggleTooltip(): void {
    if (this.disabled) {
      return;
    }
    this.active = !this.active;
    if (this.active) {
      this.subscribeClick();
    } else {
      this.unsubscribeClick();
    }
  }

  /**
   * Subscribe to click event for closing tooltip when you click somewhere except tooltip.
   * @private
   */
  private subscribeClick(): void {
    this.clickSubscription = fromEvent(document, 'click')
      .pipe(
        filter((event: Event) => this.active && !this.tooltip.nativeElement.contains(event.target))
      ).subscribe(() => {
        this.active = false;
        this.unsubscribeClick();
      });
  }

  /**
   * Unsubscribe from click event, when tooltip is closed.
   * @private
   */
  private unsubscribeClick(): void {
    if (this.clickSubscription) {
      this.clickSubscription.unsubscribe();
      this.clickSubscription = null;
    }
  }
}
